import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 30px;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-style: normal;
    font-weight: 275;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
    }
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
  margin: 0 20px;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-top: 20px;
  max-width: 1180px;
  width: 100%;
  margin: 80px auto;
  padding: 70px 0px 10px 0;

  @media (max-width: 768px) {
    max-width: 340px;
    margin: 24px auto 0;
    padding: 0;
  }

  > p {
    grid-column: 1 / -1;
    font-family: 'Open Sans';
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    text-align: left;
    padding: 0 300px 40px 0px;
    margin-bottom: 40px;

    @media (max-width: 768px) {
      padding: 0;
      margin-bottom: 20px;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

export const TextBox1 = styled.div`
  padding-left: 20px;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  line-height: 20px;
  text-align: left;
  color: #fcfcfc;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    padding: 0;
    margin-bottom: 10px;
    font-size: 20px;
    font-style: normal;
    font-weight: 275;
    line-height: 24px;
  }

  @media (max-width: 768px) {
    &.empty-content {
      display: none;
    }
  }

  &.content-left {
    margin: auto -100px;
    width: 300px;

    @media (max-width: 768px) {
      margin: 0;
      width: 100%;
    }
  }
`;

export const TextBox2 = styled.div`
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #c3c3c3;
  text-align: left;

  p {
    font-family: 'Open Sans';
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    text-align: left;
    margin: 10px 0 20px 0;

    @media (max-width: 768px) {
      margin: 5px 0 10px 0;
    }
  }
`;
